import {
  ApiResponse,
  EventLiteDto,
  EventType,
  EventCreateRequest,
  EventSearchParams,
  EventUpdateRequest,
  GridResponse,
} from '../../types/types';
import { client } from '../client';
import { urls } from '../endpoints';

export const searchEventsRequest = async (params?: EventSearchParams) => {
  try {
    const response = await client.get<ApiResponse<GridResponse<EventType[]>>>(
      urls.searchEvents(params),
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error searching events:', error);
    return null;
  }
};

export const createEvent = async (eventData: EventCreateRequest) => {
  try {
    const response = await client.post<ApiResponse<GridResponse<number>>>(
      urls.createEvent,
      eventData,
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error creating event:', error);
    return null;
  }
};

export const updateEvent = async (
  eventId: number,
  eventData: EventUpdateRequest,
) => {
  try {
    const response = await client.put(urls.updateEvent(eventId), eventData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEventDatabyEventId = async (eventId: number) => {
  try {
    const response = await client.get(`${urls.getEventById(eventId)}`);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching event data by ID:', error);
    return null;
  }
};

export const getEventsListLite = async () => {
  try {
    const response = await client.get<ApiResponse<EventLiteDto[]>>(
      urls.eventsListLite,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEventRecentRegistrations = async (eventId: number) => {
  try {
    const response = await client.get(
      `${urls.getEventRecentRegistrations(eventId)}`,
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('Error fetching event recent registrations by ID:', error);
    return null;
  }
};
